import axios from "axios";

type getDataT = <T>({ apiUrl: string }) => Promise<T>;
export const getData: getDataT = async ({ apiUrl }) =>
  axios.get(apiUrl).then((res) => res.data);
